import React from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

import { ErrorBoundary } from './ErrorBoundary';
import { LaunchpadApp } from './LaunchpadApp';

const RoutesLayout = () => {
  return <Outlet />;
};

export const router: RouteObject[] = [
  {
    // errorElement: <ErrorBoundary />,
    children: [
      {
        element: <RoutesLayout />,
        children: [
          {
            path: '/',
            element: <LaunchpadApp />,
          },
        ],
      },
    ],
  },
];

export default router;
